// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1yuCP","title":"ClientReferral_title__1NNFZ","itemText":"ClientReferral_itemText__f4Oe3"};